import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cab1111"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["name", "placeholder", "value", "disabled", "readonly"]
const _hoisted_3 = { class: "el-range-separator" }
const _hoisted_4 = ["name", "placeholder", "value", "disabled", "readonly"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popper = _resolveComponent("el-popper")!
  const _directive_clickoutside = _resolveDirective("clickoutside")!

  return (_openBlock(), _createBlock(_component_el_popper, _mergeProps({
    ref: "refPopper",
    visible: _ctx.pickerVisible,
    "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.pickerVisible) = $event)),
    placement: "bottom-start",
    "manual-mode": "",
    effect: "light",
    pure: "",
    trigger: "click"
  }, _ctx.$attrs, {
    "popper-class": `el-picker__popper ${_ctx.popperClass}`,
    transition: "el-zoom-in-top",
    "gpu-acceleration": false,
    "stop-popper-mouse-event": false,
    "append-to-body": "",
    onBeforeEnter: _cache[18] || (_cache[18] = ($event: any) => (_ctx.pickerActualVisible = true)),
    onAfterLeave: _cache[19] || (_cache[19] = ($event: any) => (_ctx.pickerActualVisible = false))
  }), {
    trigger: _withCtx(() => [
      (!_ctx.isRangeInput)
        ? _withDirectives((_openBlock(), _createBlock(_component_el_input, {
            key: 0,
            "model-value": _ctx.displayValue,
            name: _ctx.name,
            size: _ctx.pickerSize,
            disabled: _ctx.pickerDisabled,
            placeholder: _ctx.placeholder,
            class: _normalizeClass(["el-date-editor", 'el-date-editor--' + _ctx.type]),
            readonly: !_ctx.editable || _ctx.readonly || _ctx.isDatesPicker || _ctx.type === 'week',
            onInput: _ctx.onUserInput,
            onFocus: _ctx.handleFocus,
            onKeydown: _ctx.handleKeydown,
            onChange: _ctx.handleChange,
            onMouseenter: _ctx.onMouseEnter,
            onMouseleave: _ctx.onMouseLeave
          }, _createSlots({ _: 2 }, [
            (_ctx.showIcon)
              ? {
                  name: "prefix",
                  fn: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.iconSrc,
                      class: _normalizeClass(_ctx.triggerClass),
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args)))
                    }, null, 10, _hoisted_1)
                  ])
                }
              : undefined,
            (_ctx.showClose)
              ? {
                  name: "suffix",
                  fn: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(["el-input__icon", [_ctx.showClose ? '' + _ctx.clearIcon : '']]),
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClearIconClick && _ctx.onClearIconClick(...args)))
                    }, null, 2)
                  ])
                }
              : undefined
          ]), 1032, ["model-value", "name", "size", "disabled", "placeholder", "class", "readonly", "onInput", "onFocus", "onKeydown", "onChange", "onMouseenter", "onMouseleave"])), [
            [_directive_clickoutside, _ctx.onClickOutside, _ctx.popperPaneRef]
          ])
        : _withDirectives((_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["el-date-editor el-range-editor el-input__inner", [
          'el-date-editor--' + _ctx.type,
          _ctx.pickerSize ? `el-range-editor--${ _ctx.pickerSize }` : '',
          _ctx.pickerDisabled ? 'is-disabled' : '',
          _ctx.pickerVisible ? 'is-active' : ''
        ]]),
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
            onMouseenter: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
            onMouseleave: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
            onKeydown: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(['el-input__icon', 'el-range__icon', _ctx.triggerClass])
            }, null, 2),
            _createElementVNode("input", {
              autocomplete: "off",
              name: _ctx.name && _ctx.name[0],
              placeholder: _ctx.startPlaceholder,
              value: _ctx.displayValue && _ctx.displayValue[0],
              disabled: _ctx.pickerDisabled,
              readonly: !_ctx.editable || _ctx.readonly,
              class: "el-range-input",
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleStartInput && _ctx.handleStartInput(...args))),
              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleStartChange && _ctx.handleStartChange(...args))),
              onFocus: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args)))
            }, null, 40, _hoisted_2),
            _renderSlot(_ctx.$slots, "range-separator", {}, () => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.rangeSeparator), 1)
            ], true),
            _createElementVNode("input", {
              autocomplete: "off",
              name: _ctx.name && _ctx.name[1],
              placeholder: _ctx.endPlaceholder,
              value: _ctx.displayValue && _ctx.displayValue[1],
              disabled: _ctx.pickerDisabled,
              readonly: !_ctx.editable || _ctx.readonly,
              class: "el-range-input",
              onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleFocus && _ctx.handleFocus(...args))),
              onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleEndInput && _ctx.handleEndInput(...args))),
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleEndChange && _ctx.handleEndChange(...args)))
            }, null, 40, _hoisted_4),
            _createElementVNode("i", {
              class: _normalizeClass([[_ctx.showClose ? '' + _ctx.clearIcon : ''], "el-input__icon el-range__close-icon"]),
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClearIconClick && _ctx.onClearIconClick(...args)))
            }, null, 2)
          ], 34)), [
            [_directive_clickoutside, _ctx.onClickOutside, _ctx.popperPaneRef]
          ])
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {
        visible: _ctx.pickerVisible,
        actualVisible: _ctx.pickerActualVisible,
        parsedValue: _ctx.parsedValue,
        format: _ctx.format,
        unlinkPanels: _ctx.unlinkPanels,
        type: _ctx.type,
        defaultValue: _ctx.defaultValue,
        onPick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onPick && _ctx.onPick(...args))),
        onSelectRange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.setSelectionRange && _ctx.setSelectionRange(...args))),
        onSetPickerOption: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onSetPickerOption && _ctx.onSetPickerOption(...args))),
        onMousedown: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
      }, undefined, true)
    ]),
    _: 3
  }, 16, ["visible", "popper-class"]))
}